/*
 * @Author: xmountain
 * @Date: 2022-04-27 10:04:42
 * @LastEditors: xmountain
 * @LastEditTime: 2022-04-27 10:27:51
 * @Description: 
 */
import { store } from '@/store';
import types from '@/store/types';
import toast from '@kk/toast';
let blackListTeamErrorType = 'default';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function single (fn: (...args: any[]) => void) {
  let isLoading = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return async function (this: void, ...args: any[]) {
    if (isLoading) return;
    try {
      isLoading = true;
      await fn.apply(this, args);
      isLoading = false;
    } catch {
      isLoading = false;
    }
  };
}
export function setBlackListTeamErrorType (type: string) {
  blackListTeamErrorType = type;
}
export function blackListTeam () {
  const blackListTeamError: { default: string, [key: string]: string } = {
    'join': '该队伍存在违规行为，已取消其活动参与及获奖资格',
    'default': '经系统判断，您的账号存在违规行为，故取消您的活动参与及获奖资格'
  };
  request.after = function (res) {
    if (!res) return;
    if (res.code === 200) {
      store.commit(types.SET_BLACKLISTTEAM, false);
    } else if (res.code === 11113) {
      store.commit(types.SET_BLACKLISTTEAM, true);
      toast.show({
        text: blackListTeamError[blackListTeamErrorType],
        time: 2000
      });
    }
    setBlackListTeamErrorType('default');
  };
}